import React, {Component} from "react"
import Dropzone from "react-dropzone"

import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import mainTheme from "@irati/ui/src/global/theme"
import Button from "@irati/ui/src/Button"
import {Label} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import Icon, {IconTypes} from "@irati/ui/src/Icon"

interface Props extends InjectIntl {
  onDrop: (acceptedFiles: File[]) => void
}

class DragAndDrop extends Component<Props> {
  render() {
    const {onDrop} = this.props

    return (
      <Flex justifyContent="center" alignItems="center" padding={4} style={{background: mainTheme.colors.greys.lightest}}>
        <Dropzone
          className="styledDropzone"
          accept=".csv"
          multiple={false}
          onDrop={onDrop}>
          <Flex direction="column" alignItems="center">
            <Button primary marginBottom={2}>
              <Icon icon={IconTypes.uploadCSV} marginRight size={20} />
              <FormattedMessage id="platform.dragAndDrop.cta.text" />
            </Button>
            <Label large>
              <FormattedMessage id="platform.dragAndDrop.label.text" />
            </Label>
          </Flex>
        </Dropzone>
      </Flex>
    )
  }
}

export default injectIntl(DragAndDrop)
